/**
 * AuthImage — `<img>`-Ersatz für authentifizierte Image-Endpoints.
 * Lädt das Bild via authFetch und stellt es als Blob-URL bereit.
 */
import { useEffect, useState } from "react";
import { authFetch } from "../App";

export default function AuthImage({ src, alt, className, style, onError, fallback = null, draggable = false }) {
  const [blobUrl, setBlobUrl] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!src) { setBlobUrl(null); return; }
    let cancelled = false;
    let createdUrl = null;
    setError(false);
    (async () => {
      try {
        const r = await authFetch(src);
        if (!r.ok) {
          if (!cancelled) { setError(true); onError && onError(); }
          return;
        }
        const blob = await r.blob();
        if (cancelled) return;
        createdUrl = URL.createObjectURL(blob);
        setBlobUrl(createdUrl);
      } catch {
        if (!cancelled) { setError(true); onError && onError(); }
      }
    })();
    return () => {
      cancelled = true;
      if (createdUrl) URL.revokeObjectURL(createdUrl);
    };
  }, [src]);

  if (error) return fallback;
  if (!blobUrl) return <div className={className} style={style} aria-label={alt} />;
  return <img src={blobUrl} alt={alt} className={className} style={style} draggable={draggable} />;
}
